module.exports = __webpack_public_path__ + "img/deyu_mediumtitle_bg.81477c60.png";